export interface ModelOption {
  id: string;
  label: string;
}

export const MODEL_OPTIONS: ModelOption[] = [
  { id: 'gemini-2.0-flash-exp', label: 'Gemini 2.0 Flash (Experimental)' },
  { id: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash (Padrão)' },
  { id: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro (Qualidade de Estúdio)' }
];

const RATES_PER_THOUSAND: Record<string, number> = {
  'gemini-2.0-flash-exp': 0.000075,
  'gemini-2.5-flash': 0.00024,
  'gemini-2.5-pro': 0.00125
};

const DEFAULT_RATE = 0.000075;
const BRL_EXCHANGE_RATE = 5.40;

export function getRatePerThousand(modelId: string): number {
  return RATES_PER_THOUSAND[modelId] ?? DEFAULT_RATE;
}

export function calculateEstimatedCost(charCount: number, modelId: string) {
  const ratePerThousand = getRatePerThousand(modelId);
  const estimatedCostUSD = (charCount / 1000) * ratePerThousand;
  const estimatedCostBRL = estimatedCostUSD * BRL_EXCHANGE_RATE;
  return { estimatedCostUSD, estimatedCostBRL, ratePerThousand };
}
